import React, { useState } from "react";
import {
  AttributeContainer,
  BodyContent,
  SocialNetworkContainer,
  TitleContainer,
  TitleContent,
} from "./style";

import {t} from 'i18next';
import { ChannelContext } from "../../../context/channel";
import PageTitle from "../../shared/pageTitle/PageTitle";
import Label from "../../shared/label/Label";
import ColorPicker from "../../shared/colorPicker/ColorPicker";
import InputColorPicker from "../../shared/inputColorPicker/InputColorPicker";
import SocialNetwork from "../../shared/socialNetwork/SocialNetwork";

const Footer = () => {
  const dashboardContext = React.useContext(ChannelContext);

  const handleSocialNetworkInput = (
    name: string,
    checked: boolean,
    url?: string
  ) => {
    switch (name) {
      case "Facebook":
        if (!url) {
          dashboardContext.setFooterFacebook((facebook: any) => ({
            ...dashboardContext.footerFacebook,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterFacebook((facebook: any) => ({
            ...dashboardContext.footerFacebook,
            url: url,
          }));
        }
        break;
      case "Twitter":
        if (!url) {
          dashboardContext.setFooterTwitter((twitter: any) => ({
            ...dashboardContext.footerTwitter,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterTwitter((twitter: any) => ({
            ...dashboardContext.footerTwitter,
            url: url,
          }));
        }
        break;
      case "Linkedin":
        if (!url) {
          dashboardContext.setFooterLinkedin((linkedin: any) => ({
            ...dashboardContext.footerLinkedin,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterLinkedin((linkedin: any) => ({
            ...dashboardContext.footerLinkedin,
            url: url,
          }));
        }
        break;
      case "YouTube":
        if (!url) {
          dashboardContext.setFooterYoutube((youtube: any) => ({
            ...dashboardContext.footerYoutube,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterYoutube((youtube: any) => ({
            ...dashboardContext.footerYoutube,
            url: url,
          }));
        }
        break;
      case "Instagram":
        if (!url) {
          dashboardContext.setFooterInstagram((instagram: any) => ({
            ...dashboardContext.footerInstagram,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterInstagram((instagram: any) => ({
            ...dashboardContext.footerInstagram,
            url: url,
          }));
        }
        break;
      case "Site próprio":
        if (!url) {
          dashboardContext.setFooterSite((instagram: any) => ({
            ...dashboardContext.footerSite,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterSite((instagram: any) => ({
            ...dashboardContext.footerSite,
            url: url,
          }));
        }
        break;
      case "Spotify":
        if (!url) {
          dashboardContext.setFooterSpotify((spotify: any) => ({
            ...dashboardContext.footerSpotify,
            active: checked,
          }));
        } else {
          dashboardContext.setFooterSpotify((spotify: any) => ({
            ...dashboardContext.footerSpotify,
            url: url,
          }));
        }
        break;
    }
  };

  return (
    <BodyContent>
      <PageTitle>{t('dashboard.footer.title')}</PageTitle>
      <TitleContainer>
        <TitleContent>
          <Label style={{ width: "115px" }}>{t('dashboard.footer.background.color')}</Label>
          <AttributeContainer>
            <InputColorPicker
              color={dashboardContext.footerColor}
              handleChangeColor={(e) => dashboardContext.setFooterColor(e.hex)}
            />
          </AttributeContainer>
        </TitleContent>
      </TitleContainer>
      <TitleContainer style={{ marginTop: "16px" }}>
        <TitleContent>
          <Label style={{ width: "115px" }}>{t('dashboard.footer.text.color')}</Label>
          <AttributeContainer>
            <InputColorPicker
             color={dashboardContext.footerTextColor}
             handleChangeColor={(e) => dashboardContext.setFooterTextColor(e.hex)}
            />
          </AttributeContainer>
        </TitleContent>
      </TitleContainer>

      <SocialNetworkContainer>
        <Label>{t('dashboard.footer.social')}</Label>
        <SocialNetwork
          type={"Facebook"}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerFacebook}
        />
        <SocialNetwork
          type={"Twitter"}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerTwitter}
        />
        <SocialNetwork
          type={"Linkedin"}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerLinkedin}
        />
        <SocialNetwork
          type={"YouTube"}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerYoutube}
        />
        <SocialNetwork
          type={"Instagram"}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerInstagram}
        />
        <SocialNetwork
          type={"Spotify"}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerSpotify}
        />

        <SocialNetwork
          type={t('dashboard.footer.social.website')}
          handleSocialNetworkInput={handleSocialNetworkInput}
          previousData={dashboardContext.footerSite}
        />
      </SocialNetworkContainer>
    </BodyContent>
  );
};

export default Footer;
